import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./CommonLoginToHeader.css";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";
import { pinpointStatus, unAuthAddressDetails } from "../../redux/slices/authSlice";

interface Props {
  title: string;
  screen: string;
  backScreen: string;
}

const CommonLoginToHeader: React.FC<Props> = ({
  title,
  screen,
  backScreen,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector((state: RootState) => state.auth.token);

  const backHandler = () => {
    // navigate(-1);
    
    if (token && token !== "undefined") {
      navigate(-1);
    } else {
      navigate(`/${backScreen}`);
    }
  };

  const unAuthBackHandler = () => {
    // navigate(-1);
    navigate(`/`);
    sessionStorage.removeItem("unAuthAddress");
    dispatch(pinpointStatus(true));
    dispatch(unAuthAddressDetails(''));
  };

  return screen === "login" ? (
    <>
      <div className="common-header">
        {/* <i onClick={backHandler} className="fa-solid fa-arrow-left"></i> */}
        <h1>{title}</h1>
      </div>

      <hr className="common-hr-login" />

      {/* <div className="common-account">
            <h3>
              Already Have PinPoint Account?{" "}
              <Link className="common-login" to="/">
                Login Here
              </Link>
            </h3>
          </div> */}
    </>
  ) : screen === "unAuthPinpoints" ? (
    <>
      <div className="common-header">
        <i onClick={unAuthBackHandler} className="fa-solid fa-arrow-left"></i>
        <h1>{title}</h1>
      </div>

      <hr className="common-hr" />

      <div className="common-account">
        {/* <h3>
          Already Have PinPoint Account?{" "}
          <Link className="common-login" to="/">
            Login Here
          </Link>
        </h3> */}
      </div>
    </>
  ) : (
    <>
      <div className="common-header">
        <i onClick={backHandler} className="fa-solid fa-arrow-left"></i>
        <h1>{title}</h1>
      </div>

      <hr className="common-hr" />

      <div className="common-account">
        {token === "" && (
          <h3>
            Already Have PinPoint Account?{" "}
            <Link
              onClick={() => {
                dispatch(pinpointStatus(true));
                dispatch(unAuthAddressDetails(''));

              }}
              className="common-login"
              to="/"
            >
              Login Here
            </Link>
          </h3>
        )}
      </div>
    </>
  );
};

export default CommonLoginToHeader;
